<template>
  <div
    class="container-fluid menuContainer"
    style="
      display: flex;
      flex-direction: column;
      width: 100%;
      margin: 0px;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      height: fit-content;
      gap: 24px;
    "
  >
    <img
      src="../../src/assets/img/Xtrim/Xtrim-Pro-logo.png"
      style="max-width: 300px; width: auto"
    />
    <div
      class="card col-11 col-sm-7 col-md-6 col-lg-5 col-xl-4 col-xxl-4"
      style="padding: 25px"
    >
      <div class="align-items-center text-center" v-if="!started">
        <h1
          class="invite-text"
          style="
            margin-bottom: 20px;
            font-size: 22px;
            line-height: 30px;
            text-align: center;
            font-weight: 600;
            color: #7d0c7e;
          "
        >
          ¡Bienvenido a Xtrim!
        </h1>

        <h2
          class="invite-text"
          style="
            margin-bottom: 15px;
            font-size: 18px;
            text-align: center;
            color: #7d0c7e;
            font-weight: 500;
          "
        >
          🌟 ¡Transforma tu vida con la velocidad más increíble del Ecuador! 🚀
        </h2>

        <p
          style="
            margin-bottom: 20px;
            font-size: 16px;
            text-align: center;
            color: #666;
            line-height: 24px;
          "
        >
          ¡Es súper fácil! Solo completa nuestro formulario y prepárate para
          vivir una experiencia digital extraordinaria. Nuestro equipo de
          expertos te contactará para diseñar el plan perfecto que hará que tu
          internet vuele como nunca antes.
        </p>

        <div style="width: 100%">
          <button
            @click="startProcess"
            class="btn btn-yellow-normal"
            style="
              width: 100%;
              font-size: 18px;
              text-align: center;
              font-weight: 900;
            "
          >
            ¡Quiero Xtrim! 🚀
          </button>
        </div>
      </div>

      <form-digital-lead
        v-else
        :campaign="campaign"
        :campaign-city="campaignCity"
      />
    </div>

    <white-footer-component />
  </div>
</template>

<script>
/*eslint-disable */

import FormDigitalLead from "./FormDigitalLead";
import WhiteFooterComponent from "./Layouts/WhiteFooter.vue";

export default {
  name: "VentaDigital",
  components: {
    FormDigitalLead,
    WhiteFooterComponent,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      started: false,
      campaign: null,
      campaignCity: null,
    };
  },

  methods: {
    startProcess() {
      this.started = true;
    },
  },

  computed: {},
  watch: {},

  mounted() {
    document.title = "Xtrim - Solicitar Internet";

    // Get campaign parameters from URL if present
    const urlParams = new URLSearchParams(window.location.search);
    this.campaign = urlParams.get("campaign");
    this.campaignCity = urlParams.get("campaignCity");
    console.log("Campaign:", this.campaign);
    console.log("Campaign City:", this.campaignCity);
  },

  created() {},
  beforeUnmount() {},
};
</script>

<style scoped>
.container-fluid {
  padding: 0px;
  margin: 0px;
}

.bg-dark {
  background: linear-gradient(87deg, #591361, #7d0c7e) !important;
  height: 160px;
}

.menuContainer {
  display: flex;
  min-height: 100vh;
  height: 100%;
  justify-content: center;
  align-items: center;
  min-height: calc(var(--vh, 1vh) * 100);
  margin: 0px;
  padding: 0;
  background-color: #7d0c7e !important;
  background: url("../../src/assets/img/Xtrim/register-background.png")
    no-repeat center center;
  background-size: cover;
}

.invite-text {
  margin-bottom: 20px;
  font-family: "Ubuntu", sans-serif;
}

.btn-yellow-normal {
  background-color: #f9cc03;
  border-color: #f9cc03;
  color: #7d0c7e;
  font-weight: 700;
  border-radius: 8px;
  padding: 12px 24px;
  transition: all 0.3s ease;
}

.btn-yellow-normal:hover {
  background-color: #e6b800;
  border-color: #e6b800;
  color: #7d0c7e;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.card {
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: none;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}
</style>
